import FormGroup from "legacy/FormGroup"
import { snakeCaseToReadable } from "legacy/helpers.es6"
import PropTypes from "prop-types"
import React from "react"

class PricingStructureSelect extends React.Component {
  renderOptionGroup(optionGroupName, options) {
    return (
      <optgroup
        key={optionGroupName}
        label={snakeCaseToReadable(optionGroupName)}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {snakeCaseToReadable(option.name)}
          </option>
        ))}
      </optgroup>
    )
  }

  render() {
    return (
      <FormGroup
        inputType="select"
        value={this.props.pricingStructure}
        name="pricingStructure"
        label="Pricing structure"
        onChange={this.props.handleInputChange}
        disabled={this.props.disabled}
      >
        {Object.entries(this.props.pricingStructures).map(
          ([optionGroupName, options]) =>
            this.renderOptionGroup(optionGroupName, options)
        )}
      </FormGroup>
    )
  }
}

PricingStructureSelect.propTypes = {
  pricingStructure: PropTypes.string,
  pricingStructures: PropTypes.object.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
}

export default PricingStructureSelect
